import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';

import FontAwesome6 from 'react-native-vector-icons/FontAwesome6';

export const AccountMenus = styled.View`
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: ${RFValue(12)}px;
  gap: ${RFValue(8)}px;
`;

export const AccountMenuItem = styled.View`
  flex-direction: column;
  align-items: center;
  gap: ${RFValue(2)}px;
`;

export const AccountMenuIconMCI = styled(FontAwesome6)`
  font-size: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.primary};
`;


export const AccountMenuIcon = styled(FontAwesome6)`
  font-size: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.primary};
`;

export const AccountMenuTitle = styled.Text`
  text-align: center;
  font-size: ${RFValue(8.5)}px;
  line-height: ${RFValue(11)}px;
  margin-top: 1px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
`;



export const AccountIconBox = styled.View`
  width: ${RFValue(36)};
  height: ${RFValue(36)}px;
  background-color: ${({theme}) => theme.colors.primary_light};
  border-radius: ${RFValue(22)}px;
  justify-content: center;
  align-items: center;
`;

